import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { Resource, Permission } from '../../constants/permissions';
import { PageRoute } from '../../constants/routes';
import { AuthGuard } from './AuthGuard';

interface ProtectedRouteProps {
  children: React.ReactNode;
  resource: Resource;
  permission: Permission;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  resource,
  permission,
  redirectTo = PageRoute.HOME,
}) => {
  const { can } = usePermissions();

  return (
    <AuthGuard>
      {can(resource, permission) ? (
        <>{children}</>
      ) : (
        <Navigate to={redirectTo} replace />
      )}
    </AuthGuard>
  );
};

// Pre-configured protected routes for common resources
export const ProtectedMembersRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute resource={Resource.MEMBERS} permission={Permission.READ}>
    {children}
  </ProtectedRoute>
);

export const ProtectedDashboardRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute resource={Resource.DASHBOARD} permission={Permission.READ}>
    {children}
  </ProtectedRoute>
); 